"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var CheckInCircleOff = function CheckInCircleOff(props) {
  return (0, _preact.h)("svg", (0, _extends2.default)({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _preact.h)("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M1.40169 1.38672L1.38542 1.4043L14.582 14.6009L13.6491 15.5339L11.6764 13.5612C11.3406 13.7821 10.9825 13.9773 10.5996 14.1426C9.7885 14.4926 8.92157 14.6673 7.99935 14.6673C7.07713 14.6673 6.2102 14.4926 5.39909 14.1426C4.58803 13.7926 3.88252 13.3174 3.28255 12.7174C2.68258 12.1175 2.20742 11.412 1.85742 10.6009C1.50742 9.7898 1.33268 8.92287 1.33268 8.00065C1.33268 7.07843 1.50742 6.2115 1.85742 5.40039C2.02268 5.01743 2.21716 4.65882 2.43815 4.32292L0.449219 2.33398L1.39909 1.38411L1.40169 1.38672ZM4.23242 8.23372L7.06576 11.0671L8.1237 10.0085L7.19076 9.07552L7.06576 9.20052L5.16602 7.30078L4.23242 8.23372Z",
    fill: "currentColor"
  }), (0, _preact.h)("path", {
    d: "M7.99935 1.33398C8.92157 1.33398 9.7885 1.50872 10.5996 1.85872C11.4107 2.20872 12.1162 2.68388 12.7161 3.28385C13.3161 3.88382 13.7913 4.58933 14.1413 5.40039C14.4913 6.2115 14.666 7.07843 14.666 8.00065C14.666 8.92287 14.4913 9.7898 14.1413 10.6009C13.976 10.984 13.7811 11.3425 13.5599 11.6784L10.0065 8.125L11.7663 6.36719L10.8327 5.43424L9.07357 7.19206L4.32031 2.4388C4.65646 2.21769 5.0159 2.02408 5.39909 1.85872C6.2102 1.50872 7.07713 1.33398 7.99935 1.33398Z",
    fill: "currentColor"
  }));
};

var _default = CheckInCircleOff;
exports.default = _default;